import { Box, Fieldset } from '@chakra-ui/react'
import type { FC } from 'react'

import RichTextInput from '@app/next/forms/inline/richTextInput'
import type { DomainBusinessContext } from '@app/types'
import type { BusinessContext } from '@graphql/types'

interface Props {
  businessContext?: BusinessContext
}

const WelcomeBusinessContext: FC<Props> = ({ businessContext }) => {
  if (!businessContext) {
    return null
  }

  const renderedElement = (
    <Box position="relative">
      <RichTextInput domainObject={businessContext as DomainBusinessContext} name="content" placeholder="" />
    </Box>
  )

  return (
    <Fieldset.Root
      borderWidth={1}
      borderStyle="solid"
      borderColor="border.default"
      borderRadius="md"
      px={6}
      py={2}
      bg="bg"
    >
      <Fieldset.Content>{renderedElement}</Fieldset.Content>
    </Fieldset.Root>
  )
}

export default WelcomeBusinessContext
